'use client';
import BlazeSlider from 'blaze-slider';
import { useEffect, useRef } from 'react';

export default function useBlazeSlider(config) {
  const sliderRef = useRef(null);
  const elRef = useRef(null);

  useEffect(() => {
    // if not already initialized
    if (!sliderRef.current) {
      sliderRef.current = new BlazeSlider(elRef.current, config);
    }

    // Cleanup on unmount
    return () => {
      if (sliderRef.current) {
        sliderRef.current.destroy();
        sliderRef.current = null;
      }
    };

    // Keep one-time init behavior for now
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return elRef;
}
